var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Interactive",
    transform: "translate(-1153, -418)",
    fill: "#CCF2FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-buttons",
    transform: "translate(1130, 295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(10, 115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3345086,31.1801142 L21.6962127,31.1801142 L21.6962127,21.1184009 L24.9179292,21.1184009 L25.5623009,17.0540663 L21.6962127,17.0540663 L21.6962127,13.9810346 C21.6962127,12.841047 22.7866387,12.1966753 23.8275031,12.1966753 L25.7109857,12.1966753 L25.7109857,8.826274 L22.3405133,8.67758923 C19.1187968,8.47934288 17.3345086,11.0071261 17.3345086,14.0305962 L17.3345086,17.0540663 L13.6666667,17.0540663 L13.6666667,21.1184009 L17.3345086,21.1184009 L17.3345086,31.1801142 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.316415a738d9246cadc46374e8962e6f.svg";
export { ForwardRef as ReactComponent };